(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lm-featured-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setupQuickAdd = (section) => {
      if (!section || section.dataset.quickAddReady === 'true') return;
      section.dataset.quickAddReady = 'true';

      section.addEventListener('submit', async (event) => {
        const form = event.target.closest('.lm-card-quick-add');
        if (!form) return;
        event.preventDefault();

        const button = form.querySelector('.lm-card-quick-add__button');
        const buttonLabel = button?.querySelector('[data-lm-card-button-label]');
        const status = form.querySelector('[data-lm-card-status]');
        const variantId = new FormData(form).get('id');
        if (!button || !buttonLabel || !variantId) return;

        const defaultLabel = button.dataset.defaultLabel;
        button.disabled = true;
        button.classList.add('is-loading');
        buttonLabel.textContent = button.dataset.loadingLabel;
        status.textContent = '';

        try {
          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
          });

          if (!response.ok) throw new Error('Cart add failed');
          await response.json();

          button.classList.remove('is-loading');
          button.classList.add('is-added');
          buttonLabel.textContent = button.dataset.addedLabel;
          status.textContent = button.dataset.addedLabel;

          if (window.CartSidebar) {
            await window.CartSidebar.refreshCart();
            window.CartSidebar.open();
          }

          window.setTimeout(() => {
            button.classList.remove('is-added');
            buttonLabel.textContent = defaultLabel;
            button.disabled = false;
          }, 1800);
        } catch (error) {
          button.classList.remove('is-loading');
          buttonLabel.textContent = defaultLabel;
          button.disabled = false;
          status.textContent = button.dataset.errorLabel;
        }
      });
    };

    document.querySelectorAll('.lm-products').forEach(setupQuickAdd);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('.lm-products').forEach(setupQuickAdd);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lm-hero-editorial"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const wide = window.matchMedia('(min-width: 990px)');
    let frame = 0;

    const setupCarousel = (hero) => {
      if (!hero || hero.dataset.carouselReady === 'true') return;
      hero.dataset.carouselReady = 'true';
      const slides = Array.from(hero.querySelectorAll('[data-lm-hero-slide]'));
      const previous = hero.querySelector('[data-lm-hero-previous]');
      const next = hero.querySelector('[data-lm-hero-next]');
      const currentLabel = hero.querySelector('[data-lm-hero-current]');
      const status = hero.querySelector('[data-lm-hero-status]');
      if (slides.length < 2 || !previous || !next) return;
      let current = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
      let touchStartX = 0;
      let touchStartY = 0;

      const show = (index) => {
        const target = (index + slides.length) % slides.length;
        if (target === current) return;
        slides[current].classList.remove('is-active');
        slides[current].setAttribute('aria-hidden', 'true');
        slides[current].setAttribute('inert', '');
        slides[target].removeAttribute('inert');
        slides[target].setAttribute('aria-hidden', 'false');
        slides[target].classList.add('is-active');
        current = target;
        hero.dataset.activeSlide = String(current);
        if (currentLabel) currentLabel.textContent = String(current + 1).padStart(2, '0');
        if (status) status.textContent = slides[current].dataset.slideLabel || '';
        schedule();
      };

      previous.addEventListener('click', () => show(current - 1));
      next.addEventListener('click', () => show(current + 1));
      hero.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') show(current - 1);
        if (event.key === 'ArrowRight') show(current + 1);
      });
      hero.addEventListener('touchstart', (event) => {
        touchStartX = event.changedTouches[0].clientX;
        touchStartY = event.changedTouches[0].clientY;
      }, { passive: true });
      hero.addEventListener('touchend', (event) => {
        const deltaX = event.changedTouches[0].clientX - touchStartX;
        const deltaY = event.changedTouches[0].clientY - touchStartY;
        if (Math.abs(deltaX) > 52 && Math.abs(deltaX) > Math.abs(deltaY) * 1.2) show(current + (deltaX < 0 ? 1 : -1));
      }, { passive: true });
    };

    const update = () => {
      frame = 0;
      document.querySelectorAll('[data-lm-hero]').forEach((hero) => {
        const visual = hero.querySelector('[data-lm-hero-parallax]');
        if (!visual) return;
        if (motion.matches || !wide.matches || hero.dataset.activeSlide !== '1') {
          visual.style.removeProperty('--hero-shift');
          return;
        }
        const bounds = hero.getBoundingClientRect();
        if (bounds.bottom < 0 || bounds.top > innerHeight) return;
        const shift = Math.max(0, Math.min(44, -bounds.top * .07));
        visual.style.setProperty('--hero-shift', `${shift.toFixed(1)}px`);
      });
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    const setup = (root = document) => root.querySelectorAll('[data-lm-hero-carousel]').forEach(setupCarousel);
    setup();
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    motion.addEventListener('change', schedule);
    document.addEventListener('shopify:section:load', (event) => { setup(event.target); schedule(); });
    schedule();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lm-main-collection"]) return;
  try {
    
  (() => {
    const setupCollectionQuickAdd = (section) => {
      if (!section || section.dataset.quickAddReady === 'true') return;
      section.dataset.quickAddReady = 'true';

      section.addEventListener('submit', async (event) => {
        const form = event.target.closest('.lm-card-quick-add');
        if (!form) return;
        event.preventDefault();

        const button = form.querySelector('.lm-card-quick-add__button');
        const buttonLabel = button?.querySelector('[data-lm-card-button-label]');
        const status = form.querySelector('[data-lm-card-status]');
        const variantId = new FormData(form).get('id');
        if (!button || !buttonLabel || !variantId) return;

        const defaultLabel = button.dataset.defaultLabel;
        button.disabled = true;
        button.classList.add('is-loading');
        buttonLabel.textContent = button.dataset.loadingLabel;
        status.textContent = '';

        try {
          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
          });

          if (!response.ok) throw new Error('Cart add failed');
          await response.json();

          button.classList.remove('is-loading');
          button.classList.add('is-added');
          buttonLabel.textContent = button.dataset.addedLabel;
          status.textContent = button.dataset.addedLabel;

          if (window.CartSidebar) {
            await window.CartSidebar.refreshCart();
            window.CartSidebar.open();
          }

          window.setTimeout(() => {
            button.classList.remove('is-added');
            buttonLabel.textContent = defaultLabel;
            button.disabled = false;
          }, 1800);
        } catch (error) {
          button.classList.remove('is-loading');
          buttonLabel.textContent = defaultLabel;
          button.disabled = false;
          status.textContent = button.dataset.errorLabel;
        }
      });
    };

    document.querySelectorAll('.lm-collection').forEach(setupCollectionQuickAdd);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('.lm-collection').forEach(setupCollectionQuickAdd);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lm-product-main"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setupProduct = (section) => {
      if (!section || section.dataset.lmProductReady === 'true') return;
      section.dataset.lmProductReady = 'true';

      const form = section.querySelector('[data-lm-product-form]');
      const price = section.querySelector('[data-lm-product-price]');
      const addButton = section.querySelector('[data-lm-product-add]');
      const addLabel = section.querySelector('[data-lm-product-add-label]');
      const status = section.querySelector('[data-lm-product-status]');
      const quantity = form?.querySelector('input[name="quantity"]');

      section.querySelectorAll('[data-lm-product-thumb]').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const image = section.querySelector('.lm-product__main-image');
          if (!image) return;
          image.src = thumb.dataset.imageUrl;
          image.removeAttribute('srcset');
          image.alt = thumb.dataset.imageAlt || '';
          section.querySelectorAll('[data-lm-product-thumb]').forEach((item) => {
            const active = item === thumb;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', String(active));
          });
        });
      });

      form?.addEventListener('change', (event) => {
        const variant = event.target.closest('[data-lm-product-variant]');
        if (!variant || !price || !addButton || !addLabel) return;
        price.innerHTML = `<span>${variant.dataset.price}</span>${variant.dataset.comparePrice ? `<s>${variant.dataset.comparePrice}</s>` : ''}`;
        const available = variant.dataset.available === 'true';
        addButton.disabled = !available;
        addLabel.textContent = available ? addButton.dataset.defaultLabel : addButton.dataset.soldOutLabel;
      });

      section.querySelector('[data-lm-quantity-minus]')?.addEventListener('click', () => {
        if (!quantity) return;
        quantity.value = Math.max(Number(quantity.min) || 1, Number(quantity.value) - 1);
      });

      section.querySelector('[data-lm-quantity-plus]')?.addEventListener('click', () => {
        if (!quantity) return;
        quantity.value = Number(quantity.value) + 1;
      });

      form?.addEventListener('submit', async (event) => {
        if (!addButton || !addLabel) return;
        event.preventDefault();
        addButton.disabled = true;
        addButton.classList.add('is-loading');
        addLabel.textContent = addButton.dataset.loadingLabel;
        if (status) status.textContent = '';

        try {
          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: new FormData(form)
          });
          if (!response.ok) throw new Error('Cart add failed');
          await response.json();
          addButton.classList.remove('is-loading');
          addButton.classList.add('is-added');
          addLabel.textContent = addButton.dataset.addedLabel;
          if (status) status.textContent = addButton.dataset.addedLabel;

          if (window.CartSidebar) {
            await window.CartSidebar.refreshCart();
            window.CartSidebar.open();
          }

          window.setTimeout(() => {
            addButton.classList.remove('is-added');
            addButton.disabled = false;
            addLabel.textContent = addButton.dataset.defaultLabel;
          }, 1800);
        } catch (error) {
          addButton.classList.remove('is-loading');
          addButton.disabled = false;
          addLabel.textContent = addButton.dataset.defaultLabel;
          if (status) status.textContent = addButton.dataset.errorLabel;
        }
      });
    };

    document.querySelectorAll('[data-lm-product-section]').forEach(setupProduct);
    document.addEventListener('shopify:section:load', (event) => setupProduct(event.target.querySelector('[data-lm-product-section]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lm-product-related"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const loadRelated = (section) => {
      if (!section || section.dataset.loaded === 'true') return;
      section.dataset.loaded = 'true';
      const observer = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        fetch(section.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const wrapper = document.createElement('div');
            wrapper.innerHTML = text;
            const incoming = wrapper.querySelector('[data-lm-related]');
            if (incoming?.innerHTML.trim()) section.innerHTML = incoming.innerHTML;
          })
          .catch(() => {});
      }, { rootMargin: '0px 0px 300px 0px' });
      observer.observe(section);
    };

    document.querySelectorAll('[data-lm-related]').forEach(loadRelated);
    document.addEventListener('shopify:section:load', (event) => loadRelated(event.target.querySelector('[data-lm-related]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lm-product-spotlight"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const carousels = document.querySelectorAll('[data-lm-bundle-carousel]');

    carousels.forEach((carousel) => {
      if (carousel.dataset.bundleReady === 'true') return;
      carousel.dataset.bundleReady = 'true';

      const slides = Array.from(carousel.querySelectorAll('[data-lm-bundle-slide]'));
      const nextButton = carousel.querySelector('[data-lm-bundle-next]');
      const nextTitle = carousel.querySelector('[data-lm-bundle-next-title]');
      const status = carousel.querySelector('[data-lm-bundle-status]');
      if (slides.length < 2 || !nextButton) return;

      let activeIndex = 0;

      const showSlide = (newIndex) => {
        activeIndex = (newIndex + slides.length) % slides.length;

        slides.forEach((slide, index) => {
          const isActive = index === activeIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', String(!isActive));
          slide.querySelectorAll('[data-lm-bundle-focusable]').forEach((element) => {
            element.tabIndex = isActive ? 0 : -1;
          });
        });

        const upcomingIndex = (activeIndex + 1) % slides.length;
        nextTitle.textContent = slides[upcomingIndex].dataset.productTitle;
        status.textContent = `${slides[activeIndex].dataset.productTitle}, ${activeIndex + 1} / ${slides.length}`;
      };

      nextButton.addEventListener('click', () => showSlide(activeIndex + 1));
      carousel.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        showSlide(document.documentElement.dir === 'rtl' ? activeIndex - direction : activeIndex + direction);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
